import firebase from "firebase/app";
import { push } from "connected-react-router";
import {
    GET_REPORT_TITLES,
    GET_USER_DATA,
    SET_FILTER_REPORT_TYPE,
    SET_FILTER_DEPARTMENT_NAME,
    SET_FILTER_AREA_NAME,
    SET_FILTER_USER_UID,
    SET_SEARCH_DATE_FROM,
    SET_SEARCH_DATE_TO,
    SET_FILTER_DEPARTMENT,
    SET_FILTER_AREA,
    SET_SORT_TABLE_TYPE,
    SET_SORT_TABLE_KEY,
    SET_SORT_TABLE_AS,
    SET_REPORT_FILTER_STATE,
    SET_ROWS_PER_PAGE,
    SET_PAGE,
    SET_REPORT_STATUS,
    SET_SELECTED_ROW,
    SET_REPORT_EDIT_STATUS,
    SET_STATUS_CHANGE_MODAL_INFO,
    DELETE_REPORT,
    SET_DELETE_STATUS,
    SET_FILTER_JOB_ID,
    GET_JOBPACKS,
    SET_REPORT,
    PARTICULAR_REPORTS,
    SET_FILTER_YEAR,
    SET_FILTER_MONTH,
    GET_JOB_YEARS,
    SET_DAY,
    CLIENT_NAME
} from "./types";
export const getReportTitles = () => {
    return (dispatch) => {
        dispatch({ type: GET_REPORT_TITLES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_titles/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_TITLES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TITLES.FAIL });
        }
    };
};

export const getJobYears = () => {
    return (dispatch) => {
        dispatch({ type: GET_JOB_YEARS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/jobpacks/active`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_JOB_YEARS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_JOB_YEARS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_JOB_YEARS.FAIL });
        }
    };
};
export const getUserData = () => {
    return (dispatch) => {
        dispatch({ type: GET_USER_DATA.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_USER_DATA.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_USER_DATA.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USER_DATA.FAIL });
        }
    };
};

export const particularReportsdata = (uid = false) => {
    return (dispatch) => {
        dispatch({ type: PARTICULAR_REPORTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/reports/${uid}/reports`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: PARTICULAR_REPORTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: PARTICULAR_REPORTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: PARTICULAR_REPORTS.FAIL });
        }
    };
};

export const setFilterUserUid = (uid = "all_users") => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_USER_UID, payload: uid });
    };
};

export const setFilterAreaName = (areaType = "all_areas") => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_AREA_NAME, payload: areaType });
    };
};
export const setFilterDepartmentsName = (
    departmentType = "all_departments"
) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_DEPARTMENT_NAME, payload: departmentType });
    };
};
export const setFilterReportType = (reportType = "all_reports") => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_REPORT_TYPE, payload: reportType });
    };
};
export const setSearchDateFrom = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_SEARCH_DATE_FROM, payload: date });
    };
};
export const setDay = (day = false) => {
    return (dispatch) => {
        dispatch({ type: SET_DAY, payload: day });
    };
};
export const setSearchDateTo = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_SEARCH_DATE_TO, payload: date });
    };
};
export const setReportFilterState = (state = false) => {
    return (dispatch) => {
        dispatch({ type: SET_REPORT_FILTER_STATE, payload: state });
    };
};
export const setRowsPerPage = (rows = 50) => {
    return (dispatch) => {
        dispatch({ type: SET_ROWS_PER_PAGE, payload: rows });
    };
};
export const setPage = (page = 1) => {
    return (dispatch) => {
        dispatch({ type: SET_PAGE, payload: page });
    };
};

export const setClientName = (clientName = false) => {
    return (dispatch) => {
        dispatch({ type: CLIENT_NAME, payload: clientName });
    };
};

export const setReportStatus = ({
    status = "unviewed",
    uid = false,
    reportType = false,
    timestamp = false,
    year = false,
    month = false,
} = {}) => {
    return (dispatch) => {
        dispatch({ type: SET_REPORT_STATUS.REQUEST });
        if (uid && reportType && timestamp) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(
                                `/users/${uid}/receipts/${year}/${month}/${reportType}`
                            )
                            .child(timestamp)
                            .update({ worksheet_status: status })
                            .then(() =>
                                dispatch({ type: SET_REPORT_STATUS.SUCCESS })
                            )
                            .catch(() =>
                                dispatch({ type: SET_REPORT_STATUS.FAIL })
                            );
                    } else {
                        dispatch({ type: SET_REPORT_STATUS.FAIL });
                    }
                });
            } catch {
                dispatch({ type: SET_REPORT_STATUS.FAIL });
            }
        } else {
            dispatch({ type: SET_REPORT_STATUS.FAIL });
        }
    };
};

export const setSelectedRow = (row = false) => {
    return (dispatch) => {
        dispatch({ type: SET_SELECTED_ROW, payload: row });
    };
};
export const setReportEditStatus = ({
    uid = false,
    reportType = false,
    timestamp = false,
    status = false,
    year = false,
    month = false,
} = {}) => {
    return (dispatch) => {
        dispatch({ type: SET_REPORT_EDIT_STATUS.REQUEST });
        if (uid && reportType && timestamp) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(
                                `/users/${uid}/receipts/${year}/${month}/${reportType}/${timestamp}`
                            )
                            .update({ uneditable: status })
                            .then(() =>
                                dispatch({
                                    type: SET_REPORT_EDIT_STATUS.SUCCESS,
                                })
                            )
                            .catch(() => ({
                                type: SET_REPORT_EDIT_STATUS.FAIL,
                            }));
                    } else {
                        dispatch({ type: SET_REPORT_EDIT_STATUS.FAIL });
                    }
                });
            } catch {
                dispatch({ type: SET_REPORT_EDIT_STATUS.FAIL });
            }
        } else {
            dispatch({ type: SET_REPORT_EDIT_STATUS.FAIL });
        }
    };
};

export const setStatusChangeModal = ({
    state = false,
    status = false,
    uid = false,
    reportType = false,
    timestamp = false,
    type = false,
    subjectName = false,
    subjectChild = false,
} = {}) => {
    return (dispatch) => {
        dispatch({
            type: SET_STATUS_CHANGE_MODAL_INFO,
            payload: {
                state,
                status,
                uid,
                reportType,
                timestamp,
                type,
                subjectName,
                subjectChild,
            },
        });
    };
};
export const deleteReport = ({
    reportType = false,
    uid = false,
    timestamp = false,
    subjectChild = false,
    subjectName = false,
    year = false,
    month = false,
} = {}) => {
    return (dispatch) => {
        dispatch({ type: DELETE_REPORT.REQUEST });
        if (reportType && uid && timestamp && subjectChild && subjectName) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(
                                `/users/${uid}/receipts/${year}/${month}/${reportType}/${timestamp}`
                            )

                            .remove()
                            .then(() => {
                                firebase
                                    .database()
                                    .ref(
                                        `/subjects/${subjectName}/${subjectChild}/reports/${reportType}/${timestamp}`
                                    )

                                    .remove()
                                    .then(() =>
                                        dispatch({
                                            type: DELETE_REPORT.SUCCESS,
                                        })
                                    )
                                    .catch(() =>
                                        dispatch({ type: DELETE_REPORT.FAIL })
                                    );
                            })
                            .catch(() =>
                                dispatch({ type: DELETE_REPORT.FAIL })
                            );
                    } else {
                        dispatch({ type: DELETE_REPORT.FAIL });
                    }
                });
            } catch {
                dispatch({ type: DELETE_REPORT.FAIL });
            }
        } else {
            dispatch({ type: DELETE_REPORT.FAIL });
        }
    };
};
export const setDeleteStatus = () => {
    return (dispatch) => {
        dispatch({ type: SET_DELETE_STATUS });
    };
};
export const setJobID = (jobID = false) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_JOB_ID, payload: jobID });
    };
};
export const setYear = (year = false) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_YEAR, payload: year });
    };
};
export const setMonth = (month = false) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_MONTH, payload: month });
    };
};
export const setArea = (area = false) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_AREA, payload: area });
    };
};
export const setSortTableType = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SORT_TABLE_TYPE, payload: val });
    };
};

export const setSortTableAs = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SORT_TABLE_AS, payload: val });
    };
};

export const setSortTableKey = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SORT_TABLE_KEY, payload: val });
    };
};
export const setDepartment = (dep = false) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_DEPARTMENT, payload: dep });
    };
};
export const redirectTo = (link) => {
    return (dispatch) => {
        dispatch(push(link));
    };
};

export const getTotalJobPacks = (year, month) => {
    return (dispatch) => {
        dispatch({ type: GET_JOBPACKS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_JOBPACKS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/subjects/jobpacks/active/${year}/${month}`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_JOBPACKS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_JOBPACKS.FAIL });
        }
    };
};
export const setReport = (
    jobpackId,
    jobpackReports,
    timeStamp,
    reportType,
    userId,
    year,
    month,
    year1,
    month1
) => {
    let reportData = jobpackReports[reportType][timeStamp];
    console.log(reportData, "reportData");
    return (dispatch) => {
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(
                            `/subjects/jobpacks/active/${year}/${month}/${jobpackId.id}/reports/${reportType}/`
                        )
                        .child(timeStamp)
                        .update(reportData)
                        .then(() => {
                            // firebase
                            //     .database()
                            //     .ref(
                            //         `/users/${userId}/receipts/${year1}/${month1}/${reportType}/${timeStamp}/`
                            //     )
                            //     .remove()
                            // .then(() => {
                            firebase
                                .database()
                                .ref(
                                    `/users/${userId}/receipts/${year1}/${month1}/${reportType}/`
                                )
                                .child(timeStamp)
                                .update({
                                    subject_child: jobpackId.id,
                                    subject_name: `jobpacks/active/${year}/${month}`,
                                    report_type: reportType,
                                    timestamp: timeStamp,
                                    // urn: reportData.urn,
                                    // client_name : reportData.client_name
                                })
                                .then(() => {
                                    firebase
                                        .database()
                                        .ref(
                                            `/subjects/reports/${userId}/reports/${reportType}/${timeStamp}/`
                                        )
                                        .remove();
                                    dispatch({
                                        type: SET_REPORT.SUCCESS,
                                    });
                                });
                            // });
                        })
                        .catch(() => {
                            dispatch({ type: SET_REPORT.FAIL });
                        });
                } else {
                    dispatch({ type: SET_REPORT.FAIL });
                }
            });
        } catch {
            dispatch({ type: SET_REPORT.FAIL });
        }
    };
};
